const declensionByNum = (num: number, wordForms: string[]) => {
  const modBy100 = Math.abs(num) % 100

  const modBy10 = modBy100 % 10

  const fromTwoForms = () => {
    if (modBy100 > 10 && modBy100 < 20) {
      return wordForms[1]
    }

    return modBy10 === 1 ? wordForms[0] : wordForms[1]
  }

  const fromThreeForms = () => {
    if (modBy100 > 10 && modBy100 < 20) {
      return wordForms[2]
    }

    if (modBy10 > 1 && modBy10 < 5) {
      return wordForms[1]
    }

    if (modBy10 === 1) {
      return wordForms[0]
    }

    return wordForms[2]
  }

  switch (wordForms.length) {
    case 2:
      return fromTwoForms()
    default:
      return fromThreeForms()
  }
}

/**
 * @function pluralize
 * @description Подбирает верную форму множественного числа для слова.
 * */
export default (value: number, arr: Declension | Plural, withValue = true) => {
  if (withValue) {
    return `${value} ${declensionByNum(value, arr)}`
  }

  return `${declensionByNum(value, arr)}`
}
